/**
 * Options for "How did you hear about us?" (referralSource) select field.
 * Used across InsuranceFormPopup, insurance-verification, BlogForm, and ContactForm.
 */
export const REFERRAL_SOURCE_OPTIONS = [
  "Google Search",
  "Google Ads",
  "Psychology Today",
  "Linkedin",
  "Instagram",
  "Facebook",
  "YouTube",
  "Referral (Doctor/Therapist)",
  "Referral (Treatment Center)",
  "Friend or Family",
  "Insurance Provider",
  "Event / Open House",
  "Other",
];
